// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3cVYB","title":"InfoRow_title__af-Ef"};